// extracted by mini-css-extract-plugin
export default {"loadingProgress":"styles_loadingProgress__VLtxX"};